import { useEffect, useState } from 'react';
import { getAboutCopy } from './aboutCopy';

export function useAboutLanding(lang: 'cs' | 'en') {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const c = getAboutCopy(lang);

  useEffect(() => {
    const onScroll = () => {
      const next = window.scrollY > 12;
      setScrolled((prev) => (prev === next ? prev : next));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  const on = { bg: '#fff', fg: '#0065F4' };
  const off = { bg: 'transparent', fg: '#6B7280' };
  const cz = lang === 'cs' ? on : off;
  const en = lang === 'en' ? on : off;

  return {
    menuOpen01: menuOpen ? '1' : '0',
    toggleMenu: () => setMenuOpen((v) => !v),
    closeMenu: () => setMenuOpen(false),
    navBg: scrolled ? 'rgba(255,255,255,0.85)' : 'transparent',
    navTop: scrolled ? '32px' : '0px',
    navRadius: scrolled ? '999px' : '0px',
    navMax: scrolled ? '1120px' : '1200px',
    navShadow: scrolled
      ? '0 1px 0 rgba(17,24,39,0.06), 0 8px 24px rgba(17,24,39,0.05)'
      : 'none',
    navBlur: scrolled ? 'saturate(180%) blur(12px)' : 'none',
    czBg: cz.bg,
    czColor: cz.fg,
    enBg: en.bg,
    enColor: en.fg,
    langLabel: lang === 'cs' ? 'Čeština' : 'English',
    showAll,
    toggleAll: () => setShowAll((v) => !v),
    allLabel: showAll ? c.showLess : c.showAll,
    team: showAll ? c.people : c.people.slice(0, 3),
    stats: c.stats,
    avatars: c.avatars,
    quotes: c.quotes,
  };
}

export type AboutLandingVals = ReturnType<typeof useAboutLanding>;
